import classNames from 'classnames';

import { ReactComponent as TriangleIcon } from '@crazyegginc/hatch/dist/images/icon-triangle-filled.svg';
import { ReactComponent as HelpIcon } from '@crazyegginc/hatch/dist/images/icon-help-filled.svg';
import { ReactComponent as OpenUrlIcon } from '@crazyegginc/hatch/dist/images/icon-open-url-outline.svg';

import { SupportLinks } from '/src/support';

export function HelpFlyOut() {
  return (
    <div
      className="relative h-10 w-full cursor-pointer group box-border flex items-center pl-2.5 py-2.5 no-underline hover:bg-white hover:bg-opacity-[0.15] rounded-l pr-6"
      data-testid="menu-selector-help"
      role="button"
      tabIndex={0}
      aria-haspopup="menu"
    >
      <span className="flex items-center w-full">
        <HelpIcon className="h-4 w-4 fill-current text-white text-opacity-70" />

        <span className="ml-2.5 flex items-center text-nav-secondary">Help</span>
        <span className="ml-auto">
          <TriangleIcon
            aria-label="expand"
            className={classNames(' -rotate-90 fill-current text-solitude-500 h-2 w-2')}
          />
        </span>
      </span>
      <div
        className="absolute left-[calc(100%-5px)] z-[9999] hidden max-h-[90vh] w-[250px] flex-col items-start overflow-y-auto overflow-x-hidden rounded bg-white shadow-lg group-hover:flex group-focus-within:flex"
        data-testid="menu_help"
      >
        <div className="box-border flex w-full items-center px-3.5 py-3 hover:bg-alice-blue-500">
          <a
            className="flex w-full items-center"
            href={SupportLinks.general.helpCenter}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="text-header-6 flex items-center">
              Help Center <OpenUrlIcon aria-label="open in new tab" className="fill-current h-2.5 w-2.5 ml-2.5" />
            </span>
          </a>
        </div>
        <div className="box-border flex w-full items-center border-t border-dashed border-mystic-500 px-3.5 py-3 hover:bg-alice-blue-500">
          <a
            className="flex w-full items-center"
            href={SupportLinks.general.newSupportRequest}
            target="_blank"
            rel="noreferrer noopener"
          >
            <span className="text-header-6 flex items-center">
              Contact Support <OpenUrlIcon aria-label="open in new tab" className="fill-current h-2.5 w-2.5 ml-2.5" />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}
